import { GoogleCalendar } from "datebook";
import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Button, InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import './reminder.style.css';

export function Reminder() {
    const formRef = useRef(null);
    const [dateStart, setDateStart] = useState();
    const [dateStartTouched, setDateStartTouched] = useState(false);
    const [dateEnd, setDateEnd] = useState("");
    const [dateEndTouched, setDateEndTouched] = useState(false);
    const [timeStart, setTimeStart] = useState("");
    const [timeStartTouched, setTimeStartTouched] = useState(false);
    const [timeEnd, setTimeEnd] = useState("");
    const [timeEndTouched, setTimeEndTouched] = useState(false);
    const [validated, setValidated] = useState(true);

    useEffect(() => {
        setValidated(!!dateStart && !!dateEnd && !!timeStart && !!timeEnd);
    }, [dateStart, dateEnd, timeStart, timeEnd])

    const handleSubmit = (event) => {
        if (!formRef.current.checkValidity()) {
            setValidated(true);
            return;
          }
        const googleCalendar = new GoogleCalendar({
            title: "Lembrete de Leitura",
            start: new Date(`${dateStart}T${timeStart}`),
            end: new Date(`${dateEnd}T${timeEnd}`)
        });
        window.open(googleCalendar.render(), "_blank");
    }
    return (
        <>
            <h1>Crie um Lembrete de Leitura!</h1>
            <h3 className="pageSubtitle">Sincronize com a sua agenda do Google</h3>
            <div className="container container-reminder">
                <div className="second-container">
                    <h2 className="reminder-date">Período</h2>
                    <Form ref={formRef} validated={validated} className='forms forms-new-user'>
                        <Form.Group className="mb-3 reminder-label">
                            <Form.Label className="form-label-reminder">Data Início</Form.Label>
                            <InputGroup hasValidation className="reminder-input">
                                <Form.Control required onTouchStart={() => setDateStartTouched(true)} onChange={(e) => setDateStart(e.target.value)} type="date" isInvalid={dateStartTouched && !dateStart}/>
                                <Form.Control.Feedback type="invalid">
                                    É necessário preencher a data de início.
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3 reminder-label">
                            <Form.Label className="form-label-reminder">Data Fim</Form.Label>
                            <InputGroup hasValidation className="reminder-input">
                                <Form.Control required onTouchStart={() => setDateEndTouched(true)} onChange={(e) => setDateEnd(e.target.value)} type="date" isInvalid={dateEndTouched && !dateEnd} min={dateStart}/>
                                <Form.Control.Feedback type="invalid">
                                    É necessário preencher a data de fim.
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3 reminder-label">
                            <Form.Label className="form-label-reminder">Horário Início</Form.Label>
                            <InputGroup hasValidation className="reminder-input">
                                <Form.Control required onTouchStart={() => setTimeStartTouched(true)} onChange={(e) => setTimeStart(e.target.value)} type="time" isInvalid={timeStartTouched && !timeStart}/>
                                <Form.Control.Feedback type="invalid">
                                    É necessário preencher o horário de início.
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3 reminder-label">
                            <Form.Label className="form-label-reminder">Horário Fim</Form.Label>
                            <InputGroup hasValidation className="reminder-input">
                                <Form.Control required onTouchStart={() => setTimeEndTouched(true)} onChange={(e) => setTimeEnd(e.target.value)} type="time" isInvalid={timeEndTouched && !timeEnd} min={dateStart === dateEnd ? timeStart : undefined}/>
                                <Form.Control.Feedback type="invalid">
                                    É necessário preencher o horário de fim.
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                    </Form>
                    <Button className="button button-reminder" variant='outline-success' onClick={handleSubmit}>CRIAR LEMBRETE</Button>
                </div>
            </div>
        </>
    )
}